import { useLocation } from "react-router-dom";
import { Container } from "./styles";
import { useEffect, useState } from "react";
import PaymentHistory from "../../../models/PaymentHistory.model";
import { addComma } from "../../../utils/Utils";
import moment from "moment";

export default function PaymentCompletePage() {

  const location = useLocation();  

  const [paymentHistory, setPaymentHistory] = useState<PaymentHistory|null>(null);
  const [payMethod, setPayMethod] = useState('');

  useEffect(() => {
    
    const history = location.state;
    setPaymentHistory(history);

    if(history.data !== null) {
      const paymentData = JSON.parse(history.data);
      setPayMethod(paymentData.pay_method === 'card' ? '카드' : '휴대폰')
    }
  }, [location])

  if(paymentHistory === null) return <></>

  return (
    <Container className="payment_complete">
      <div className="inner page_inner">
        <p className="page_title"><span>결제 완료</span></p>

        <ul>
          <li>
            <p className="ttl">상품명</p>
            <p className="cont">{paymentHistory.product}</p>
          </li>
          <li>
            <p className="ttl">결제금액</p>
            <p className="cont">{addComma(paymentHistory.amount)}원</p>
          </li>
          <li>
            <p className="ttl">결제수단</p>
            <p className="cont">{payMethod}</p>
          </li>
          <li>
            <p className="ttl">결제일시</p>
            <p className="cont">{moment(paymentHistory.paidAt).format('YYYY.MM.DD HH:mm:ss')}</p>
          </li>
        </ul>
      </div>
    </Container>
  )
}